function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
  fill: "#1978f2",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2347 5110 c-626 -57 -1187 -323 -1622 -771 -379 -390 -613 -864 -696 -1410 -31 -205 -31 -533 0 -738 83 -546 317 -1020 696 -1410 360 -371 834 -632 1315 -725 47 -9 93 -18 103 -20 16 -4 17 44 17 890 l0 894 -325 0 -325 0 0 370 0 370 325 0 325 0 0 359 c0 397 6 462 61 617 107 305 331 497 659 564 94 20 128 21 325 17 184 -4 433 -26 483 -42 9 -3 12 -76 12 -318 l0 -314 -212 -6 c-263 -7 -317 -20 -402 -98 -108 -99 -126 -176 -126 -556 l0 -223 355 0 c312 0 355 -2 355 -15 0 -17 -96 -652 -106 -698 l-6 -27 -299 0 -299 0 0 -894 0 -894 78 15 c507 93 987 353 1357 734 379 390 613 864 696 1410 31 205 31 533 0 738 -83 546 -317 1020 -696 1410 -397 409 -901 668 -1461 751 -160 23 -442 33 -587 20z"
}));

var SvgFbLogo = function SvgFbLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFbLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fb-logo.f4b0f97f.svg";
export { ForwardRef as ReactComponent };